import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './OrganizerDashboard.css';
import BrandingSetup from './BrandingSetup';
import SessionList from './SessionList';
import CreateSession from './CreateSession';
import SessionDetail from './SessionDetail';
import ResultsDashboard from './ResultsDashboard';

const OrganizerDashboard = () => {
  const [activeTab, setActiveTab] = useState('sessions');
  const [organizer, setOrganizer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSession, setSelectedSession] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch('/api/organizer/check-auth', {
        credentials: 'include',
      });
      const data = await response.json();
      
      if (data.authenticated) {
        setOrganizer(data);
        if (data.branding) {
          localStorage.setItem('organizer_branding', JSON.stringify(data.branding));
        }
      } else {
        navigate('/organizer/login');
      }
    } catch (err) {
      console.error('Auth check failed:', err);
      navigate('/organizer/login');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch('/api/organizer/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.error('Logout error:', err);
    }
    localStorage.removeItem('organizer_id');
    localStorage.removeItem('organizer_email');
    localStorage.removeItem('organizer_name');
    localStorage.removeItem('organizer_company');
    localStorage.removeItem('organizer_branding');
    navigate('/organizer/login');
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!organizer) {
    return null;
  }

  return (
    <div className="organizer-dashboard">
      <header className="dashboard-header">
        <div className="header-content1">
          <h1>Persona Screening</h1>
          <div className="header-actions">
            <span className="user-info">
              {organizer.name} ({organizer.company_name})
            </span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="dashboard-content">
        <nav className="dashboard-nav">
          <button
            className={activeTab === 'sessions' ? 'active' : ''}
            onClick={() => {
              setActiveTab('sessions');
              setSelectedSession(null);
            }}
          >
            Sessions
          </button>
          <button
            className={activeTab === 'create' ? 'active' : ''}
            onClick={() => {
              setActiveTab('create');
              setSelectedSession(null);
            }}
          >
            Create Session
          </button>
          <button
            className={activeTab === 'branding' ? 'active' : ''}
            onClick={() => {
              setActiveTab('branding');
              setSelectedSession(null);
            }}
          >
            Branding
          </button>
          <button
            className={activeTab === 'results' ? 'active' : ''}
            onClick={() => {
              setActiveTab('results');
              setSelectedSession(null);
            }}
          >
            Results
          </button>
        </nav>

        <div className="dashboard-main">
          {activeTab === 'sessions' && (
            <SessionList
              organizerId={organizer.organizer_id}
              onSelectSession={setSelectedSession}
            />
          )}
          {activeTab === 'create' && (
            <CreateSession organizerId={organizer.organizer_id} />
          )}
          {activeTab === 'branding' && (
            <BrandingSetup organizerId={organizer.organizer_id} />
          )}
          {activeTab === 'results' && (
            <ResultsDashboard organizerId={organizer.organizer_id} />
          )}
        </div>

        {selectedSession && (
          <SessionDetail
            sessionId={selectedSession}
            organizerId={organizer.organizer_id}
            onClose={() => setSelectedSession(null)}
          />
        )}
      </div>
    </div>
  );
};

export default OrganizerDashboard;

